<div class="pdf-page app-aul-029-24" id="aul02924">
  <!-- <app-policy-header></app-policy-header>-->
  <p class="font-large" style="text-align: center">
    <b> PRIOR LOSS EXCLUSION </b>
  </p>

  <p class="font-medium">
    <b> THIS ENDORSEMENT CHANGES THE POLICY. PLEASE READ CAREFULLY.</b>
  </p>
  <br />
  <p class="font-small">
    This endorsement modifies insurance provided under the following forms.
    <br />
    CAUSES OF LOSS - SPECIAL FORM
  </p>
  <br />
  <p class="font-small">
    The following <b>Prior Loss Exclusion</b> is added to this policy:
  </p>
  <p class="font-small"><b>Prior Loss Exclusion</b></p>
  <br />
    <ol class="font-small">
    <li style="padding-bottom: 10px;">
      We will not pay for any loss or damage that occurred prior to the effective
      date of this policy, including any continuation, change or resumption of
      such loss or damage during the policy period.
    </li>
    <li style="padding-bottom: 10px;">
      We will not pay for any loss or damage caused by, contributed by, or 
      resulting from any pre-existing damage or loss to property insured under this policy. 
    </li>
    <li style="padding-bottom: 10px;">
      In the event the effective date of this Policy is prior to the date coverage was requested to be bound, 
      this Policy will not pay for any loss or damage occurring between the effective date of this Policy and 
      the date coverage was requested to be bound. 
    </li>
  </ol>
  <br />
  <p class="font-small">
    Pre-existing damage means damage that pre-dates the effective date the policy. 
    Pre-existing damage includes lack of maintenance and wear and tear to covered property that results in damage prior to the date of loss. Damage means physical harm to something in such a way as to impair its value, usefulness or normal function. 
  </p>
<br />
  <p class="font-small">
    <b>All other terms and conditions of this policy remain unchanged.</b>
  </p>
</div>
